var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueDom",staticStyle:{"display":"none"},attrs:{"id":"app"},on:{"click":function($event){return _vm.isDo()}}},[_c('div',{staticClass:"dontent"},[(_vm.isRouter)?_c('router-view'):_vm._e()],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506eab4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/supubwps-document-conversion/App.vue
// module id = null
// module chunks = 